import clsx from 'clsx'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import {getUserByToken} from '../../../../app/modules/auth/core/_requests'
import {updateAbility} from '../../../common/rbac/Ability'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../common/rbac/Can'
import {useCompanies} from '../../../../app/modules/auth/core/Companies'
import {CompanySwitchModal} from './CompanySwitch'
import {useState} from 'react'

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const Navbar = () => {
  const {config} = useLayout()
  const user: any = useAuth()
  const ability = useAbility(AbilityContext)
  const {saveAuth, setCurrentUser} = useAuth()
  const [companySwitch, setCompanySwitch] = useState(false)
  const {defaultCompany, companies, updateDefaultCompany} = useCompanies()

  


  return (
    <>
      <CompanySwitchModal
        show={companySwitch}
        handleClose={function (): void {
          setCompanySwitch(false)
        }}
      />
      <div className='app-navbar flex-shrink-0'>
        <div className={clsx('app-navbar-item align-items-stretch d-none', itemClass)}>
          <Search />
        </div>

        <div className={clsx('app-navbar-item d-none', itemClass)}>
          <div id='kt_activities_toggle' className={btnClass}>
            <KTSVG path='/media/icons/duotune/general/gen032.svg' className={btnIconClass} />
          </div>
        </div>

        <div className={clsx('app-navbar-item d-none', itemClass)}>
          <div
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            className={btnClass}
          >
            <KTSVG path='/media/icons/duotune/general/gen022.svg' className={btnIconClass} />
          </div>
          <HeaderNotificationsMenu />
        </div>

        <div className={clsx('app-navbar-item d-none', itemClass)}>
          <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
            <KTSVG path='/media/icons/duotune/communication/com012.svg' className={btnIconClass} />
            <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
          </div>
        </div>

        <div className={clsx('app-navbar-item', itemClass)}>
          <img src='/media/avatars/icons8-company-48.png' className='w-30px me-5' />
          <div>
            <div className='form-select form-select-solid fw-bolder' onClick={()=>{setCompanySwitch(true)}}>
              {defaultCompany?.company_name ?? ''}
            </div>
            {/* <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => handleCompanyChange(e.target.value)}
              value={defaultCompany?.company_id}
            >
              {companies.map((company: any) => (
                <option key={company.company_id} value={company.company_id}>
                  {company.company_name}
                </option>
              ))}
            </select> */}
          </div>
        </div>
        <div className={clsx('app-navbar-item', itemClass)}>
          <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
        </div>
        {/* begin::Input group- */}

        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='' />
          </div>
          <HeaderUserMenu />
        </div>

        {/* header menu */}
        {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )} */}
      </div>{' '}
    </>
  )
}

export {Navbar}
